export default {
  getCorporation: {
    server: '/corporations/{corporationId}',
    method: 'get',
  },
  putCorporation: {
    server: '/corporations/{corporationId}',
    method: 'put',
  },
  patchCorporationContacts: {
    server: '/corporations/{corporationId}/contacts',
    method: 'patch',
  },
  postCoordinate: {
    server: '/coordinates',
    method: 'post',
  },
  initCoordinate: {
    server: '/coordinates/init',
    method: 'post',
  },
  putCoordinate: {
    server: '/coordinates/{coordinateId}',
    method: 'put',
  },
  deleteCoordinate: {
    server: '/coordinates/{coordinateId}',
    method: 'delete',
  },
};

